import React, { useEffect, useMemo, useState } from 'react';
import componentConstants from '../../core-utils/messages/componentConstants';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  Breadcrumbs,
  PageTitleAndSubTitle,
  Table,
  Download,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  DownloadButtons,
  OnHoverRowComponent,
  REGULATORY_REPORTS_TABLE_DATA,
  REPORTS_TABLE_DATA,
  getReportsTableColumns,
  getTitle,
  CUSTOM_REPORT_TABLE_DATA,
} from '../../core-utils/helper-utils/reportsTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useNavigate } from 'react-router-dom';
import { HOME_SCREEN } from '../../core-utils/routes';
import { useStores } from '../../stores';
import clsx from 'clsx';
import properties from '../../core-utils/properties';
import DownloadReportsPlanPeriodModal from '../../_components/molecules/DownloadReportsPlanPeriodModal';
import { downloadMultipleReports } from '../../core-utils/helper-utils/downloadPdfHelper';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import PopUpNotifer from '../../_components/molecules/PopUpNotifier';
import {
  CustomDashboardsTopRightItem,
  getHighEmphasisText,
  getMediumEmphasisText,
} from '../../core-utils/helper-utils/homePageHelper';
import axios from 'axios';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  getEmployersDataFromIds,
  getLastUpdatedForEmployerGroups,
  getPlanPeriodDates,
  getReportsDataFromIds,
} from '../../core-utils/helper-utils/reportsWorkFlowHelper';
import { getTruncatedText } from '../MemberSummaryPage';
import { getMonthInNumberFormat } from '../../core-utils/helper-utils/helper';
import EditIcon from '../../_components/atoms/Icons/EditIcon';
import CreateIcon from '../../_components/atoms/Icons/CreateIcon';
import CreateNewInternalReportsModal from '../../_components/organisms/CreateNewInternalReportsModal';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import { formatEmailSchedulerData } from '../../core-utils/helper-utils/emailSchedulerHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { observer } from 'mobx-react';
import QuaterlyReportModal from '../../_components/molecules/QuaterlyReportModal';
// import EditDurationModal from '../../_components/molecules/EditDurationModal';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';

export interface ReportPageProps {}

const Reports: React.FC<ReportPageProps> = observer(({}) => {
  //styles
  const useStyles = makeStyles()({
    root: {
      margin: '40px 0px 66px 63px',
      flexDirection: 'column',
      width: '1186px',
    },
    breadCrumbsGrid: {
      marginBottom: '20px',
    },

    //table styles
    tableCard: {
      margin: '28px 0px',
    },
    tableRoot: {
      padding: '0px',
    },
    tableHeaderText: {
      fontWeight: 500,
      color: patientAccessTheme.palette.text.highemphasis,
      fontSize: '12px',
      lineHeight: '12px',
    },
    tableFirstColumn: {
      width: 'max-content',
      paddingLeft: '0px',
    },
    tableCellText: {
      fontWeight: 400,
      color: patientAccessTheme.palette.text.mediumemphasis,
      fontSize: '14px',
      lineHeight: '24px',
    },
    tableTHForRowTop: {
      height: '48px',
      backgroundColor: patientAccessTheme.palette.grey[100],
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      textAlign: 'left',

      display: 'flex',
      alignItems: 'center',
    },
    tableTHSelection: {
      paddingLeft: '26px',
      // width: '106px',
    },
    tableRow: {
      height: 'auto',
      minHeight: '56px',
      padding: '0px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '& td:first-child': {
        paddingLeft: '26px',
      },
      '&:hover': {
        backgroundColor: patientAccessTheme.palette.grey[300],
      },
      display: 'flex',
      alignItems: 'center',
    },
    tableRowQRT: {
      height: 'auto',
      minHeight: '56px',
      padding: '0px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:hover': {
        backgroundColor: patientAccessTheme.palette.grey[300],
      },
      display: 'flex',
      alignItems: 'center',
    },

    subRows: {
      backgroundColor: patientAccessTheme.palette.grey[100],
    },
    checkboxChecked: {
      color: `${patientAccessTheme.palette.primary[500]} !important`,
    },
    onHoverGrid: {
      width: 'fit-content',
      position: 'absolute',
      top: '16px',
      right: '8px',
    },
    onHoverIcon: {
      height: '20px',
      width: '20px',
      marginRight: '12px',
      cursor: 'pointer',
    },
    subTitleParts: {
      whiteSpace: 'break-spaces',
      display: 'flex',
    },
    bottomGrid: {
      margin: '10px 0px 28px 0px',
      width: '1203px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    pagination: {
      position: 'absolute',
      right: '24px',
      bottom: '20px',
    },
    flex: {
      display: 'flex',
      visibility: 'hidden',
    },
  });
  const { classes } = useStyles();

  //function to update lastUpdated property in reports table data
  const getUpdatedReportsTableData = (lastUpdated: string) => {
    REPORTS_TABLE_DATA?.map((item) => {
      item.lastUpdated = lastUpdated ?? '-';
       
      item.subRows?.map((item) => {
        item.lastUpdated = lastUpdated ?? '-';
      });
    });

    return REPORTS_TABLE_DATA;
  };

  //hooks and stores
  const navigate = useNavigate();
  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const customReportsStore = useStores().customReportsStore;
  const reportsTableData = useMemo(
    () =>
      getUpdatedReportsTableData(
        employerGroupStore.employerGroupResponseData.last_updated,
      ),
    [],
  );
  const regulatoryReportsTableData = useMemo(
    () => REGULATORY_REPORTS_TABLE_DATA,
    [],
  );
  const navigationStore = useStores().navigationStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const { isPlanDatesFetched } = quaterlyReportStore;
  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();

  // navigation
  const navigateToHomeScreen = () => {
    employerGroupStore.removeDeductibleAmount();
    employerGroupStore.removeMemberIdsCrossing50PercentDeductible();
    navigate(HOME_SCREEN);
  };

  //states
  const [reportRowId, setReportRowId] = useState<number>();
  const [regularReportRowId, setRegularReportRowId] = useState<number>();
  const [selectedReports, setSelectedReports] = useState<any[]>([]);
  const [selectedRegulatoryReports, setSelectedRegulatoryReports] = useState<
    any[]
  >([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  // const [isAnnaulPeriod, setIsAnnualPeriod] = useState<boolean>(true);
  const [finalSelectedReports, setFinalSelectedReports] = useState<string[]>(
    [],
  );
  const [modalTitleMessage, setModalTitleMessage] = useState<string>('');
  const [isReportsModalOpen, setIsReportsModalOpen] = useState(false);
  const [customReportsData, setCustomReportsData] = useState<any>([]);
  const [reportsPageNumber, setReportsPageNumber] = useState<number>(1);
  const [reportsTotalPages, setReportsTotalPages] = useState<number>(0);
   
  const [reportsPageSize, setReportsPageSize] = useState<number>(10);
  const [customReportsLoading, setCustomReportsLoading] = useState(true);
  const [openQuaterlyReport, setOpenQuaterlyReport] = useState<boolean>(false);

  //constants
  const pageConstants = componentConstants.PAGES.REPORTS;
  const breadCrumpItemList = [
    [
      'text',
      'Home',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      navigateToHomeScreen,
    ],
    [
      'text',
      'Reports',
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ],
  ];
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const allReportsIds = [
    'summaryReport',
    'diseasePrevalenceReport',
    'chronicPrevalenceReport',
    // 'riskReport',
    'careQualityReport',
    'episodesOfCareReport',
    'highCostReport',
    'stoplossAggregateReport',
    'stopLossReport',
    'stoploss5050Report',
    'planPerformanceReport',
    'claimsReport',
    'enrollmentReport',
    // 'networkLeakageReport',
    'rejectedClaimsReport',
    // 'pendingClaimsReport',
    // 'utilizationSummaryReport',
    'utilizationPatientReport',
    'utilizationPharmacyReport',
    'utilizationProcedureReport',
    'utilizationProviderReport',
    // 'wasteCalculatorReport',
  ];
  const requestBody = {
    ...payload,
    reports: finalSelectedReports,
    employer:
      employerGroupStore?.employerGroupResponseData?.employer_group_name,
    deductible_amount: employerGroupStore?.deductibleAmount,
    riskProbability: 0.7,
    claim_id_list: [],
    member_unique_id_list: [],
    member_ids_crossing_50_percent_deductible:
      employerGroupStore?.memberIdsCrossing50PercentDeductible,
    maxClaimDate: employerGroupStore?.employerGroupResponseData?.max_claim_date,
    networkIndicator:
      employerGroupStore.employerGroupResponseData.network_indicator_list,
  };

  //table functions
  const handleReportRowMouseEnter = (row: any) => {
    setReportRowId(row?.id);
  };

  const handleRegularReportRowMouseEnter = (row: any) => {
    setRegularReportRowId(row?.id);
  };

  const handleMouseLeave = () => {
    setReportRowId(NaN);
    setRegularReportRowId(NaN);
  };

  //snack bar functions
  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  //funtion to get all selected report ids
  const getSelectedReportIds = () => {
    const reportIds: string[] = [];
    // let isAnnaulPeriod = false;
    selectedReports?.map((row: any) => {
      if (row?.original?.subRows && row?.isExpanded !== true) {
        row?.original?.subRows?.map((item: any) => {
          reportIds.push(item?.id);
          // if (item.downloadFrequency === 'Annual') {
          // isAnnaulPeriod = true;
          // }
        });
      } else {
        // if (row?.original?.downloadFrequency === 'Annual') {
        // isAnnaulPeriod = true;
        // }
        reportIds.push(row?.original?.id);
      }
    });
    // setIsAnnualPeriod(isAnnaulPeriod);
    //removing group ids or non-report ids
    const finalReportIds = reportIds?.filter((item) =>
      allReportsIds?.includes(item),
    );

    return finalReportIds;
  };

  //function to set on hover report ids
  const setOnHoverReportIds = (row: any) => {
    setOpenModal(true);
    const reportIds: string[] = [];
    // setIsAnnualPeriod(
    //   row?.original?.downloadFrequency === 'Annual' ? true : false,
    // );
    if (row?.original.subRows) {
      row?.original?.subRows?.map((item: any) => {
        reportIds.push(item.id);
      });
    } else {
      reportIds.push(row?.original?.id);
    }
    setFinalSelectedReports(reportIds);
  };

  //function to handle download all button on click
  const handleDownloadAll = () => {
    setOpenModal(true);
    setModalTitleMessage(pageConstants.MODAL.TITLE.DOWNLOAD_ALL);
    setFinalSelectedReports(allReportsIds);
    // setIsAnnualPeriod(true);
  };

  //function to handle download selected button on click
  const handleDownloadSelected = () => {
    setOpenModal(true);
    setModalTitleMessage(pageConstants.MODAL.TITLE.DOWNLOAD_SELECTED);
    setFinalSelectedReports(getSelectedReportIds());
  };

  //function to donwload pdf for selected reports
  const handleReportPdfDownload = () => {
    setOpenModal(false);
    downloadMultipleReports(
      'reports',
      requestBody,
      handleOpenSnackBar,
      'download',
    );
    handleOpenSnackBar(
      snackBarMessages.SNACKBAR_MESSAGES.DOWNLOAD_REPORT,
      'info',
      6000,
    );
    navigationStore.handleOpenPopUpNotifier(true);
  };

  //common table props
  const commonTableProps = {
    widthOfTable: '1130px',
    showPagination: false,
    showFiltering: false,
    showSelection: true,
    overallGridStyles: classes.tableRoot,
    classNameForTableHeaderRowTop: classes.tableTHForRowTop,
    classNameForTableHeader: classes.tableTHForRowTop,
    classNameForTableHeaderRowForSelection: clsx(
      classes.tableTHForRowTop,
      classes.tableTHSelection,
    ),
    classNameForTableDataRow: classes.tableRow,
    classNameForTableDataRowInDepth: clsx(classes.tableRow, classes.subRows),
    isManualPagination: true,
    controlledPageIndex: 0,
    showEditData: true,
    handleMouseLeave: handleMouseLeave,
    hideSelectionForSubRows: true,
    hideSelectionHeader: false,
  };

  //Reports modal functions
  const handleCloseReportModal = () => {
    customReportsStore.removeCustomReportsData();
    setIsReportsModalOpen(false);
  };

  const handleReportCreateNewButton = () => {
    setIsReportsModalOpen(true);
  };

  const handleCustomReportsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setReportsPageNumber(value);
  };
  // const handleDateChange = () => {
  //   setStartDate(employerGroupStore?.selectedDuration?.startDate);
  //   setEndDate(employerGroupStore?.selectedDuration?.endDate);
  // };

  const deleteMultipleCustomReports = async (CustomReportIds: string[]) => {
    await axios
      .post(
        properties.userManagementBaseUrl +
          properties.customReports +
          properties.multipleDelete,
        CustomReportIds,
      )
      .then((response) => {
        if (response.status === 200) {
          handleOpenSnackBar(
            'Custom report(s) deleted succesfully',
            'success',
            6000,
          );
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
  };

  const getAllCustomReports = async () => {
    setCustomReportsLoading(true);
    const params = {
      createdBy: loginPageStore.userId,
      employerGroupIdString:
        employerGroupStore.employerGroupResponseData.eg_nid[0],
      page: reportsPageNumber - 1,
      size: reportsPageSize,
    };

    await axios
      .get(properties.userManagementBaseUrl + properties.customReports, {
        params,
      })
      .then((response) => {
        if (response.status === 200) {
          setCustomReportsData(response?.data?.customReports);
          setReportsPageNumber(response?.data?.currentPage + 1);
          setReportsTotalPages(response?.data?.totalPages);
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      );
    setCustomReportsLoading(false);
  };

  const handleSave = () => {
    customReportsStore.isEdit
      ? handleOpenSnackBar('Custom report updated succesfully', 'success', 6000)
      : handleOpenSnackBar('Custom report saved succesfully', 'success', 6000);

    customReportsStore.removeCustomReportsData();
    getAllCustomReports();
  };

  const CustomReportsTable = () => {
    const reportsConstants = componentConstants.PAGES;
    const [reportRowId, setReportRowId] = useState<number>();
    const [selectedReports, setSelectedReports] = useState<any[]>([]);

    const customReportsTableColumns = [
      {
        Header: (
          <Typography
            className={clsx(classes.tableFirstColumn, classes.tableHeaderText)}
            style={{
              width: '210px',
              paddingLeft: '16px',
            }}
          >
            {'Report Name'}
          </Typography>
        ),
        accessor: 'name',
        Cell: ({ value }: any) => (
          <Typography
            fontSize="14px"
            fontType="regular"
            lineHeight="24px"
            textColor={patientAccessTheme.palette.text.highemphasis}
          >
            {value}
          </Typography>
        ),
      },
      {
        Header: (
          <Typography
            className={clsx(classes.tableFirstColumn, classes.tableHeaderText)}
            style={{
              width: '210px',
            }}
          >
            {'Section'}
          </Typography>
        ),
        accessor: 'selectedReportIds',
        Cell: ({ value }: any) => {
          const reportNames = getReportsDataFromIds(value);
          let sections = '';
          if (Array.isArray(reportNames)) {
            reportNames.forEach((item: any) => {
              sections += item?.name + ' | ';
            });
          }
          return getTruncatedText(
            sections.substring(0, sections.length - 2),
            '200px',
          );
        },
      },
      {
        Header: (
          <Typography
            className={clsx(classes.tableFirstColumn, classes.tableHeaderText)}
            style={{
              width: '210px',
            }}
          >
            {'Selected Cohorts'}
          </Typography>
        ),
        accessor: 'selectedCohorts',
         
        Cell: ({ row }: any) => {
          const { startMonth, endMonth, startYear, endYear } =
            row?.original || {};
          const selectedCohorts = [];
          selectedCohorts.push(
            'Date: ' +
              startMonth +
              ' ' +
              startYear +
              ' - ' +
              endMonth +
              ' ' +
              endYear,
          );

          let selected_cohorts = '';
          if (Array.isArray(selectedCohorts)) {
            selectedCohorts.forEach((item) => {
              selected_cohorts += item + ' | ';
            });
          }
          return (
            getTruncatedText(
              selected_cohorts.substring(0, selected_cohorts.length - 2),
              '200px',
            ) ?? '-'
          );
        },
      },
      {
        Header: (
          <Typography
            className={clsx(classes.tableFirstColumn, classes.tableHeaderText)}
            style={{
              width: '210px',
            }}
          >
            {'Last Updated'}
          </Typography>
        ),
        accessor: 'lastUpdated',
         
        Cell: ({ row }: any) => (
          <Typography
            fontSize="14px"
            fontType="regular"
            lineHeight="24px"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {getLastUpdatedForEmployerGroups(
              row?.original?.employerGroupIds,
              employerGroupStore.allEmployerGroupsData,
            )}
          </Typography>
        ),
      },
      // {
      //   Header: (
      //     <Typography
      //       className={clsx(classes.tableFirstColumn, classes.tableHeaderText)}
      //       style={{
      //         width: '210px',
      //       }}
      //     >
      //       {'Download Frequency'}
      //     </Typography>
      //   ),
      //   accessor: 'downloadFrequency',
      //   Cell: ({ value }: any) => (
      //     <Typography
      //       fontSize="14px"
      //       fontType="regular"
      //       lineHeight="24px"
      //       textColor={patientAccessTheme.palette.text.mediumemphasis}
      //     >
      //       {getTruncatedText(value, '100px')}
      //     </Typography>
      //   ),
      // },
    ];

    const handleReportRowMouseEnter = (row: any) => {
      setReportRowId(row?.id);
    };

    const handleReportRowMouseLeave = () => {
      setReportRowId(NaN);
    };

    const handleSelectedReportsDonwload = () => {};

    const handleSelectedReportsDelete = async () => {
      const customReportsIds: string[] = [];
      selectedReports?.map((item: any) => {
        customReportsIds.push(item.original.id);
      });

      await deleteMultipleCustomReports(customReportsIds);
      await getAllCustomReports();
    };

    const ReportsOnHoverRowData = (row: any) => {
      const handleDownloadReports = () => {
        const { selectedReportIds } = row?.row?.original || {};

        const requestBody = {
          ...payload,
          reports: selectedReportIds,
          employer:
            employerGroupStore.employerGroupResponseData.employer_group_name,
          deductible_amount: employerGroupStore?.deductibleAmount,
          riskProbability: 0.7,
          claim_id_list: [],
          member_unique_id_list: [],
          member_ids_crossing_50_percent_deductible:
            employerGroupStore?.memberIdsCrossing50PercentDeductible,
          networkIndicator:
            employerGroupStore.employerGroupResponseData.network_indicator_list,
        };
        downloadMultipleReports(
          'reports',
          requestBody,
          handleOpenSnackBar,
          'download',
        );
        handleOpenSnackBar(
          'Report is being downloaded please wait...',
          'info',
          6000,
        );
        navigationStore.handleOpenPopUpNotifier(true);
      };

      const handleEditReports = () => {
        const {
          id,
          name,
          employerGroupIds,
          selectedReportIds,
          downloadFrequency,
          emailSchedulerDTO,
          startMonth,
          startYear,
          endMonth,
          endYear,
        } = row?.row?.original || {};
        const selectedEmployers = getEmployersDataFromIds(
          employerGroupIds,
          employerGroupStore.allEmployerGroupsData,
        );
        customReportsStore.setCustomReportsData(
          id,
          name,
          getReportsDataFromIds(selectedReportIds),
          selectedEmployers,
          true,
          getPlanPeriodDates(selectedEmployers),
          {
            startDate:
              startYear + '-' + getMonthInNumberFormat(startMonth) + '-01',
            endDate: endYear + '-' + getMonthInNumberFormat(endMonth) + '-01',
          },
          downloadFrequency,
          formatEmailSchedulerData(emailSchedulerDTO),
        );
        setIsReportsModalOpen(true);
      };
      return (
        <Grid container className={classes.onHoverGrid}>
          <Grid className={classes.onHoverIcon} onClick={handleDownloadReports}>
            <Download
              stroke={patientAccessTheme.palette.status.icon}
              height="20px"
              width="20px"
            />
          </Grid>
          <Grid className={classes.onHoverIcon} onClick={handleEditReports}>
            <EditIcon />
          </Grid>
        </Grid>
      );
    };

    return (
      <Grid container>
        <Grid container className={classes.bottomGrid}>
          <CardComponent
            title={reportsConstants.REPORTS.CUSTOM_REPORTS.TITLE}
            subTitle={
              <div className={classes.subTitleParts}>
                {getMediumEmphasisText(
                  reportsConstants.REPORTS.CUSTOM_REPORTS.SUBTITLE.PART1,
                )}
                {getHighEmphasisText(
                  reportsConstants.REPORTS.CUSTOM_REPORTS.SUBTITLE.PART2,
                )}
                {getMediumEmphasisText(
                  reportsConstants.REPORTS.CUSTOM_REPORTS.SUBTITLE.PART3,
                )}
                {getHighEmphasisText(
                  reportsConstants.REPORTS.CUSTOM_REPORTS.SUBTITLE.PART4,
                )}
                {getMediumEmphasisText(
                  reportsConstants.REPORTS.CUSTOM_REPORTS.SUBTITLE.PART5,
                )}
              </div>
            }
            width="1178px"
            height="auto"
            padding={
              customReportsData?.length > 0
                ? '20px 24px 60px 20px'
                : '20px 24px 24px 20px'
            }
            body={
              customReportsLoading ? (
                <CircularLoader />
              ) : (
                <Grid>
                  <Table
                    {...commonTableProps}
                    columns={customReportsTableColumns}
                    data={customReportsData}
                    showSelection={true}
                    showOptionsOnSelectionInHeader={true}
                    showDownloadSelected={false}
                    downloadSelectedButtonText={
                      reportsConstants.REPORTS.CUSTOM_REPORTS.DOWNLOAD_SELECTED
                    }
                    handleOnClickForDownloadSelectButton={
                      handleSelectedReportsDonwload
                    }
                    showDeleteSelected={true}
                    deleteSelectedButtonText={
                      reportsConstants.REPORTS.CUSTOM_REPORTS.DELETE_SELECTED
                    }
                    handleOnClickForDeleteSelectButton={
                      handleSelectedReportsDelete
                    }
                    showEditData
                    onHoverRowData={(row: any) => (
                      <ReportsOnHoverRowData row={row} />
                    )}
                    handleSelectedRows={setSelectedReports}
                    rowId={reportRowId}
                    handleMouseEnter={handleReportRowMouseEnter}
                    handleMouseLeave={handleReportRowMouseLeave}
                    isDataEmpty={customReportsData?.length === 0}
                    emptyDataWidget={
                      <NoDataVisual
                        height="350px"
                        width="inherit"
                        content={
                          reportsConstants.REPORTS.CUSTOM_REPORTS
                            .EMPTY_DATA_MESSAGE
                        }
                      />
                    }
                  />
                  {customReportsData?.length > 0 && (
                    <div className={classes.pagination}>
                      <Pagination
                        page={reportsPageNumber}
                        count={reportsTotalPages}
                        onChange={handleCustomReportsTablePageChange}
                        size="small"
                        color="primary"
                      />
                    </div>
                  )}
                </Grid>
              )
            }
            topRightItem={
              <CustomDashboardsTopRightItem
                text={reportsConstants.REPORTS.CREATE_NEW}
                icon={<CreateIcon />}
                handleOnClick={handleReportCreateNewButton}
              />
            }
          />
        </Grid>
      </Grid>
    );
  };

  const CustomQuaterlyTable = () => {
    const reportsConstants = componentConstants.PAGES;

    return (
      <Grid container>
        <Grid container className={classes.bottomGrid}>
          <CardComponent
            title={reportsConstants.REPORTS.CUSTOM_REPORTS.QUATERLY_TITLE}
            subTitle={reportsConstants.REPORTS.REPORTS_TABLE_SUBTITLE}
            width="1178px"
            height="auto"
            padding={
              customReportsData?.length > 0
                ? '20px 24px 60px 20px'
                : '20px 24px 24px 20px'
            }
            body={
              isPlanDatesLoading ? (
                <CircularLoader />
              ) : (
                <Table
                  {...commonTableProps}
                  data={CUSTOM_REPORT_TABLE_DATA}
                  showSelection={false}
                  columns={getReportsTableColumns(true, setOpenQuaterlyReport)}
                  onHoverRowData={() => {}}
                  rowId={reportRowId}
                  classNameForTableDataRow={classes.tableRowQRT}
                />
              )
            }
          />
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  useEffect(() => {
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    getAllCustomReports();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  return (
    <>
      <PopUpNotifer />
      <Grid container className={classes.root}>
        <Grid className={classes.breadCrumbsGrid}>
          <Breadcrumbs itemList={breadCrumpItemList} />
        </Grid>
        <Grid>
          <PageTitleAndSubTitle
            title={getTitle(
              employerGroupStore.employerGroupResponseData
                .employer_group_name[0],
            )}
            chip={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="2px 8px 0px 0px"
                >
                  for
                </Typography>
                {/* <EditDurationModal
                  isYearGrid={true}
                  handleDateChange={handleDateChange}
                /> */}
                <DateFilter />
              </Grid>
            }
            subTitle={pageConstants.SUBTITLE}
          />
        </Grid>
        <Grid className={classes.tableCard}>
          <CardComponent
            title={pageConstants.REPORTS}
            subTitle={pageConstants.REPORTS_TABLE_SUBTITLE}
            width="1178px"
            height="auto"
            body={
              <Table
                {...commonTableProps}
                data={reportsTableData}
                columns={getReportsTableColumns()}
                onHoverRowData={(row) => (
                  <OnHoverRowComponent
                    handleDownloadReport={() => {
                      setModalTitleMessage(
                        pageConstants.MODAL.TITLE.DOWNLOAD_SELECTED,
                      );
                      setOnHoverReportIds(row);
                    }}
                  />
                )}
                handleSelectedRows={setSelectedReports}
                rowId={reportRowId}
                handleMouseEnter={handleReportRowMouseEnter}
              />
            }
            topRightItem={
              <DownloadButtons
                showDownloadSelected={Boolean(selectedReports.length)}
                handleDownloadAll={handleDownloadAll}
                handleDowloadSelected={handleDownloadSelected}
              />
            }
          />
        </Grid>
        <Grid
          style={{
            display: checkUserAccess(
              UserAccessConstants.CUSTOM_DASHBOARD,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )
              ? 'initial'
              : 'none',
          }}
        >
          <CustomQuaterlyTable />
        </Grid>
        {/* hiding regulatory reports for now */}
        {false && (
          <Grid>
            <CardComponent
              title={pageConstants.REGULATORY_REPORTS}
              subTitle={pageConstants.REGULATORY_REPORTS_TABLE_SUBTITLE}
              width="1178px"
              height="auto"
              body={
                <Table
                  {...commonTableProps}
                  data={regulatoryReportsTableData}
                  columns={getReportsTableColumns()}
                  onHoverRowData={() => (
                    <OnHoverRowComponent
                      handleDownloadReport={() => {
                        setOpenModal(true);
                      }}
                    />
                  )}
                  handleSelectedRows={setSelectedRegulatoryReports}
                  rowId={regularReportRowId}
                  handleMouseEnter={handleRegularReportRowMouseEnter}
                />
              }
              topRightItem={
                <DownloadButtons
                  showDownloadSelected={Boolean(
                    selectedRegulatoryReports.length,
                  )}
                  handleDownloadAll={() => {}}
                  handleDowloadSelected={() => {}}
                />
              }
            />
          </Grid>
        )}
        <Grid
          style={{
            display: checkUserAccess(
              UserAccessConstants.CUSTOM_DASHBOARD,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )
              ? 'initial'
              : 'none',
          }}
        >
          <CustomReportsTable />
          {isReportsModalOpen && (
            <CreateNewInternalReportsModal
              open={isReportsModalOpen}
              handleClose={handleCloseReportModal}
              handleSave={() => handleSave()}
            />
          )}
        </Grid>
      </Grid>
      <DownloadReportsPlanPeriodModal
        // startDateUseState={[startDate, setStartDate]}
        // endDateUseState={[endDate, setEndDate]}
        open={openModal}
        handleClose={() => setOpenModal(false)}
        // isYearSelection={isAnnaulPeriod}
        title={modalTitleMessage}
        handleDownload={handleReportPdfDownload}
      />
      <QuaterlyReportModal
        open={openQuaterlyReport}
        handleClose={() => setOpenQuaterlyReport(false)}
        setOpen={setOpenQuaterlyReport}
        isQuaterlyReport={true}
      />
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
});
export default Reports;
